<template>
  <div>
    <b class="highlight">{{ parametro.nome }}</b>
    {{ criterio }}
    <obrigatorio v-if="parametro.required" />
  </div>
</template>

<script>
  export default {
    name: 'ModeloParametrosLabel',

    components: {
      Obrigatorio: () => import('@/components/general/GeneralMarkObrigatorio')
    },

    props: {
      parametro: {
        type: Object,
        required: true
      }
    },

    computed: {
      criterio() {
        switch (this.parametro.criterio.toUpperCase()) {
          case '=':
            return 'é igual a';
          case '<>':
            return 'é diferente de:';
          case '>=':
            return 'é maior ou igual a:';
          case '<=':
            return 'é menor ou igual a:';
          case '>':
            return 'é maior que:';
          case '<':
            return 'é menor que:';
          case 'IN':
            return 'pertence à lista:';
          case 'NOT IN':
            return 'não pertence à lista:';
          case 'LIKE %X%':
            return 'contém';
          case 'NOT LIKE %X%':
            return 'não contém';
          case 'LIKE X%':
            return 'começa com';
          case 'LIKE %X':
            return 'termina com';
          default:
            return '';
        }
      }
    }
  };
</script>

<style>
  .highlight {
    color: #e5502c !important;
  }
</style>
